RivalIQ.apps.Analyze.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const insights = widgets.insights = {};

    /**
     * The types of insights.
     */
    insights.type = {
        KEYWORDS_ON_PAGE_ONE: 'keywords-on-page-one',
        BEST_CHANNEL: 'best-channel',
        BEST_CHANNEL_PER_DIEM: 'best-channel-per-diem',
        RANK: 'rank',
        CHANGE: 'change',
        RANK_OR_CHANGE: 'rank-or-change'
    };

    (function () {

        const definitions = {};

        /**
         * Gets the maximum submetric from an array of submetrics.
         * @param submetrics
         */
        function getMaxSubmetric(submetrics) {

            let index = -1;

            _.reduce(submetrics, function (memo, submetric, i) {
                if (RivalIQ.state.landscape.channelAccess(submetric.source)) {

                    const value = _.result(submetric, 'value');

                    if (value > memo) {

                        index = i;
                        return value;
                    }
                }

                return memo;
            }, -Infinity);

            return (index >= 0 ? submetrics[index] : {});
        }

        /**
         * Generates the best channel insight.
         * @param config
         */
        definitions[insights.type.BEST_CHANNEL] = function (config) {
            const subject = _.result(config, 'subject');

            return function (data) {
                let channel = 'N/A';

                if (_.isFinite(data.value)) {
                    const max = getMaxSubmetric(data.submetrics);
                    channel = RivalIQ.data.channels.get(max.source).get('name');
                }

                return [
                    ['Most ', subject, ':'].join(''),
                    channel
                ].join(' ');
            };
        };

        /**
         * Generates the best channel per diem insight.
         * @param config
         */
        definitions[insights.type.BEST_CHANNEL_PER_DIEM] = function (config) {
            const preamble = ['Most ', _.result(config, 'subject'), ':'].join('');

            return function (metric) {
                const total = metric.dataValues.company.value;

                if (_.isFinite(total)) {
                    const submetrics = metric.dataValues.company.submetrics;
                    const days = metric.company.periodSummary.dates.mainPeriodDuration;

                    const max = getMaxSubmetric(submetrics);
                    const value = max.value;
                    const dividend = value / days;
                    const formatter = RivalIQ.formatter;

                    return [preamble].concat([
                        RivalIQ.data.channels.get(max.source).get('name'),
                        [
                            '(',
                            (dividend > 99 ?
                                formatter.formatAbbreviated(dividend, ',.0f') :
                                formatter.formats.fixed(dividend)),
                            '/day)'
                        ].join('')
                    ]).join(' ');
                }

                return [preamble, 'N/A'].join(' ');
            };
        };

        definitions[insights.type.RANK] = function () {
            return function (metric) {
                return new RivalIQ.apps.Dashboard.widgets.RankView({
                    model: metric,
                    tagName: 'span',
                    className: null
                }).render().el.outerHTML;
            };
        };

        definitions[insights.type.CHANGE] = function () {
            return function (metric) {
                return new RivalIQ.apps.Dashboard.widgets.TrendView({
                    model: metric,
                    tagName: 'span',
                    className: null
                }).render().el.outerHTML;
            };
        };

        /**
         * Generates a ranking or change insight given available data.
         * @param config
         */
        definitions[insights.type.RANK_OR_CHANGE] = function (config) {
            return function (metric) {
                const model = metric.clone({
                    normalized: metric.isNormalizable()
                });

                if (_.isFinite(model.getDeltaRel({
                    format: false
                }))) {
                    return definitions[insights.type.CHANGE](config)(metric);
                }

                return definitions[insights.type.RANK](config)(metric);
            };
        };

        /**
         * Gets an insight from a configuration, and optional context.
         * @param config
         * @param [context]
         */
        insights.getFromConfig = function (config, context) {

            const type = _.result(config, 'type');
            const insight = definitions[type](config, context);
            return insight;
        };

    }());

});
